import { AxiosResponse, HttpStatusCode } from 'axios';

import { ProductState } from '../../../common/enums';
import { SearchModifier } from '../../enums';
import { EmptyResults, SearchDto, SearchParameters, SearchResults } from '../../models';
import { productCatalogueHttp } from '../product-catalogue-api';

const emptyResult: EmptyResults = { count: 0, items: [] };

const failedToFetchSearchResultsLabel = 'Failed to fetch search results';

const buildSearchUrl = (include?: ProductState, searchModifier?: SearchModifier): string => {
  const includeUrlPart = include ? `?include=${ProductState[include].toLocaleLowerCase()}` : '';
  const searchModifierUrlPart = searchModifier
    ? `/${SearchModifier[searchModifier].toLocaleLowerCase()}`
    : '';
  return `/search${searchModifierUrlPart}${includeUrlPart}`;
};

export const getSearchResults = async (
  searchParameters: SearchParameters
): Promise<SearchResults | EmptyResults> => {
  try {
    const url = buildSearchUrl(searchParameters.include, searchParameters.searchModifier);
    const data: SearchDto = {
      marketLocale: searchParameters.locale === 'en' ? 'en-us' : searchParameters.locale,
      search: searchParameters.searchQuery,
      filter: searchParameters.productSearchFilter,
      orderBy: searchParameters.orderBy || '',
      skip: searchParameters.skip,
      top: searchParameters.numberOfResultsPerPage,
    };

    const response = await productCatalogueHttp.post<SearchDto, AxiosResponse<SearchResults>>(
      url,
      data
    );
    return response.status === HttpStatusCode.NoContent ? { ...emptyResult } : response.data;
  } catch (error) {
    console.error(`${failedToFetchSearchResultsLabel}:`, error);
    return { ...emptyResult, error: error };
  }
};
